import { useEffect, useState } from "react";
import axios from "axios";
import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TextMarquee } from "@/components/site/TextMarquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { ServiceArea } from "@/components/site/ServiceArea";
import { FAQ } from "@/components/site/FAQ";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [services, setServices] = useState([]);
  const [addons, setAddons] = useState([]);
  const [selectedService, setSelectedService] = useState("");

  useEffect(() => {
    axios.get(`${API}/services`).then((r) => setServices(r.data)).catch(() => {});
    axios.get(`${API}/addons`).then((r) => setAddons(r.data)).catch(() => {});
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App bg-background">
        <Navbar />
        <main>
          <Hero />
          <TextMarquee />
          <Services services={services} addons={addons} onSelect={setSelectedService} />
          <Manifesto />
          <ServiceArea />
          <FAQ />
          <Booking services={services} addons={addons} selectedService={selectedService} setSelectedService={setSelectedService} />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
